

function dealerDsrManagement() {

    let profileService = [
        {
            name: "DSR Management",
            icon: "DSR Management",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "dealerDSRManagement",
            items: [],

        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/dealerDSRManagement",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD",
            },
        ];

        return dashboardArr;
    };

    const dsrMaster = () => {
        const profileArr = [
            {
                path: "/index/dsrMaster",
                name: "DSR Master",
                icon: "fee-master",
                logoName: "dsr_Master",
                flag:"DSR MASTER"
            },
        ];
        return profileArr;
    };

    const dsrTransaction = () => {
        const profileArr = [
            {
                path: "/index/dsrTransaction",
                name: "DSR Transaction",
                icon: "fee-master",
                logoName: "dsr_Transaction",
                flag:"DSR TRANSACTION"
            },
        ];
        return profileArr;
    };


    let a = dashboard();
    let b = dsrMaster();
    let c = dsrTransaction();

    profileService[0].items = [...a, ...b, ...c];

    return profileService;
}

export default dealerDsrManagement;
